import React from 'react';
import styled from 'styled-components';

const Wrap = styled.a`
	color: inherit;
	text-decoration: none;
	cursor: pointer;
`;

export default props => (
	<Wrap
		{...props}
		target={props.target ? props.target : '_blank'}
		rel="noopener noreferrer"
		onClick={e => {
			if (typeof props.onClick === `function`) {
				props.onClick();
			}

			e.preventDefault();
			e.stopPropagation();

			// Check if to log or not.
			const internalLink = new RegExp('/' + window.location.host + '/');
			const currentHref = props.href;

			// Go to the link.
			window.open(currentHref, '_blank');

			if (
				!internalLink.test(currentHref) &&
				currentHref !== undefined &&
				'' !== currentHref &&
				'#' !== currentHref &&
				'#!' !== currentHref &&
				window.ga
			) {
				window.ga(`send`, `event`, {
					eventCategory: `EXTERNAL_LINK`,
					eventAction: `CLICK`,
					eventLabel: currentHref,
					transport: 'beacon',
				});
			}

			return false;
		}}
	>
		{props.children}
	</Wrap>
);
